import React from "react";
import Valper from "./Valper";


const HelSoesken = (props) => {
    const {valper} = props;

    return (
        <div>
            <div className="splitt-title-grey">
                Helsøskende
            </div>

            <Valper valper={valper} />


        </div>
    );
};

export default HelSoesken;